import { useEffect, useState, useCallback, useMemo, createContext, useContext } from "react";
import { api } from "./api";
import { useAuth } from "./auth";

const EntitlementsContext = createContext(null);

export const EntitlementsProvider = ({ children }) => {
  const { business } = useAuth();
  const [ent, setEnt] = useState(null);

  const refresh = useCallback(async () => {
    if (!business) { setEnt(null); return; }
    try { const r = await api.get("/entitlements"); setEnt(r.data); }
    catch (err) { console.error("Entitlements refresh failed:", err); setEnt(null); }
  }, [business]);

  useEffect(() => { refresh(); }, [refresh]);

  const value = useMemo(() => ({ ...ent, refresh }), [ent, refresh]);
  return <EntitlementsContext.Provider value={value}>{children}</EntitlementsContext.Provider>;
};

export const useEntitlements = () => useContext(EntitlementsContext) || {};
